module.exports = __webpack_public_path__ + "img/sastooutlet.b3a13d82.png";